import React from "react"
import Hero from "./layout_builder/hero"
import Columns from "./layout_builder/columns"
import LogoCarousel from "./layout_builder/logocarousel"
import IntroPanel from "./layout_builder/intropanel"
import VimeoEmbed from "./layout_builder/vimeoembed"
import Marquee from "./layout_builder/marquee"
import TeamCarousel from "./layout_builder/teamcarousel"
import HoverBullets from "./layout_builder/hover-bulletpoints"
import ContentBlock from "./layout_builder/contentblock"
import ImageBlock from "./layout_builder/imageblock"
import LogoStrip from "./layout_builder/logostrip"
import ContactDetails from "./layout_builder/contactdetails"
import ContactForm from "./layout_builder/contactform"
import ContactForm2022 from "./layout_builder/contactform2022"
import TextAndImage from "./layout_builder/textAndImage"
import LargeImage from "./layout_builder/largeImage"
import PhotographerProfile from "./layout_builder/photographerprofile"
import AllServices from "./layout_builder/allservices"

const AllSections = ({ sectionData, blogPost }) => {
  const layoutType = sectionData.fieldGroupName

  /**
   * Default component
   */
  const Default = () => <div>Missing module: {layoutType}</div>

  /**
   * Mapping the fieldGroupName(s) to our components
   */
  const layouts = {
    page_Layoutbuilder_LayoutBuilder_Hero: Hero,
    page_Layoutbuilder_LayoutBuilder_Columns: Columns,
    page_Layoutbuilder_LayoutBuilder_LogoCarousel: LogoCarousel,
    page_Layoutbuilder_LayoutBuilder_IntroPanel: IntroPanel,
    page_Layoutbuilder_LayoutBuilder_VimeoEmbed: VimeoEmbed,
    page_Layoutbuilder_LayoutBuilder_Marquee: Marquee,
    page_Layoutbuilder_LayoutBuilder_TeamCarousel: TeamCarousel,
    page_Layoutbuilder_LayoutBuilder_HoverBulletpoints: HoverBullets,
    page_Layoutbuilder_LayoutBuilder_ContentBlock: ContentBlock,
    page_Layoutbuilder_LayoutBuilder_ImageBlock: ImageBlock,
    page_Layoutbuilder_LayoutBuilder_LogoStrip: LogoStrip,
    page_Layoutbuilder_LayoutBuilder_ContactDetails: ContactDetails,
    page_Layoutbuilder_LayoutBuilder_ContactForm: ContactForm,
    page_Layoutbuilder_LayoutBuilder_ContactForm2022: ContactForm2022,
    page_Layoutbuilder_LayoutBuilder_Services: AllServices,

    post_Layoutbuilder_LayoutBuilder_Hero: Hero,
    post_Layoutbuilder_LayoutBuilder_Columns: Columns,
    post_Layoutbuilder_LayoutBuilder_LogoCarousel: LogoCarousel,
    post_Layoutbuilder_LayoutBuilder_IntroPanel: IntroPanel,
    post_Layoutbuilder_LayoutBuilder_VimeoEmbed: VimeoEmbed,
    post_Layoutbuilder_LayoutBuilder_Marquee: Marquee,
    post_Layoutbuilder_LayoutBuilder_TeamCarousel: TeamCarousel,
    post_Layoutbuilder_LayoutBuilder_HoverBulletpoints: HoverBullets,
    post_Layoutbuilder_LayoutBuilder_ContentBlock: ContentBlock,
    post_Layoutbuilder_LayoutBuilder_ImageBlock: ImageBlock,
    post_Layoutbuilder_LayoutBuilder_LogoStrip: LogoStrip,
    post_Layoutbuilder_LayoutBuilder_ContactDetails: ContactDetails,
    post_Layoutbuilder_LayoutBuilder_ContactForm: ContactForm,
    post_Layoutbuilder_LayoutBuilder_ContactForm2022: ContactForm2022,
    post_Layoutbuilder_LayoutBuilder_Services: AllServices,

    Service_Serviceslayoutbuilder_ServicesLayoutBuilder_TextAndImage: TextAndImage,
    Service_Serviceslayoutbuilder_ServicesLayoutBuilder_LargeImage: LargeImage,
    Service_Serviceslayoutbuilder_ServicesLayoutBuilder_PhotographerProfile: PhotographerProfile,
    Service_Serviceslayoutbuilder_ServicesLayoutBuilder_VimeoEmbed: VimeoEmbed,

    page_default: Default,
  }

  /**
   * If layout type is not existing in our mapping, it shows our Default instead.
   */
  const ComponentTag = layouts[layoutType]
    ? layouts[layoutType]
    : layouts["page_default"]

  return <ComponentTag content={sectionData} blogPost={true} />
}

export default AllSections
